export class AwsEc2Resource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<InventoryVolume>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2Resource.attributeTypeMap;
    }
    constructor() {
    }
}
